<h2 mat-dialog-title class="dialog-title-block">
  <span class="dialog-title">{{ data.dateLabel }}</span>
  <span class="dialog-subtitle">{{ data.locationLabel }}</span>
</h2>

<mat-dialog-content>
  @if (data.existingEvent) {
  <div class="existing">
    <span class="existing-label">Eksisterende:</span>
    <a
      class="existing-link"
      [href]="getEventUrl()"
      target="_blank"
      rel="noopener noreferrer"
      (click)="$event.stopPropagation()"
    >
      <strong>{{ data.existingEvent.name }}</strong>
      <mat-icon class="open-icon" aria-hidden="true">open_in_new</mat-icon>
    </a>
  </div>
  }

  @if (showGroupPicker) {
  <p class="pick-label">Vælg gruppe</p>
  <mat-form-field appearance="outline" class="group-picker-field">
    <mat-label>Gruppe</mat-label>
    <mat-select [(ngModel)]="selectedGroupId">
      @for (g of data.dayGroupOptions; track g.group_id) {
      <mat-option [value]="g.group_id">{{ g.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }

  <p class="pick-label">Vælg skabelon</p>
  @if (data.templates.length > 0) {
  <div class="template-list">
    @for (tpl of data.templates; track tpl) {
    <button
      type="button"
      class="template-item"
      [class.selected]="selectedTemplateId === tpl.template_id"
      (click)="selectTemplate(tpl.template_id)"
    >
      <span
        class="swatch"
        [style.background-color]="getColor(tpl.template_id)"
      ></span>
      <span class="name">{{ tpl.name }}</span>
    </button>
    }
  </div>
  } @if (data.templates.length === 0) {
  <p class="empty-hint">
    Ingen skabeloner fundet. Opret skabeloner under «Skabelon til events».
  </p>
  } @if (selectedTemplate && loadingExistingEventPatch) {
  <p class="empty-hint">Henter event-detaljer…</p>
  } @if (selectedTemplate && !loadingExistingEventPatch) {
  <div class="event-form-section hide-survey-submit">
    <p class="pick-label">Event-detaljer</p>
    <app-dynamic-form
      #eventForm
      [dynamicInput]="{
        surveyJSON: { type: 'surveyJSON', value: getEventFormConfig() },
        formReceiveFunction: { type: 'text', value: '' },
        settings: { type: 'json', value: eventFormSettings },
        modalData: { type: 'json', value: eventFormData }
      }"
    >
    </app-dynamic-form>
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (data.existingEvent) {
  <button
    mat-stroked-button
    type="button"
    class="open-tab-btn"
    (click)="openInNewTab()"
  >
    <mat-icon>open_in_new</mat-icon>
    Åbn i ny fane
  </button>
  }
  <span class="actions-spacer"></span>
  <button mat-button type="button" (click)="cancel()">Annuller</button>
  @if (data.existingEvent) {
  <button mat-button color="warn" type="button" (click)="remove()">Slet</button>
  }
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="!canConfirmCreate"
    (click)="data.existingEvent ? replace() : confirm()"
  >
    {{ data.existingEvent ? "Erstat" : "Opret" }}
  </button>
</mat-dialog-actions>
